<div class="container-fluid px-0 pb-5">
    <div class="container px-0">
        <div class="row">
            <div class="col-12 mb-3">
                <button class="w-100" mat-flat-button (click)="backToDashboard();"><mat-icon>chevron_left</mat-icon>Back
                    to dashboard</button>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-auto">
                <h1 class="mb-1">QUEUE</h1>
                <h5 class="mb-0">Selected me as therapist</h5>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                @if (queue.length > 0){
                @for (item of queue; track item){
                <div class="card p-3 my-3">


                    <div class="row">
                    <div class="col">
                    {{item.fullName}}
                    <br>
                    <span class="text-muted small">Booked on {{item.bookingDate | date:'dd MMM YYYY @ HH:mm'}}</span>
                    </div>
                    <div class="col-auto">
                     <button class="w-100" mat-flat-button color="primary" [disabled]="acceptMassageClicked || currentBooking.bookingID > 0" (click)="acceptMassage(item.bookingID);">Accept
                            massage</button>
                    </div>
</div>
                </div>
                }
                } @else{
                <p>Nobody in queue</p>
                }

            </div>
        </div>
    </div>
</div>
